import ApplicationController from "../../application_component_controller"
import { fetchTurbo } from "hb/lib/fetch";
import URL from "hb/lib/url";

export default class extends ApplicationController {
  static targets = ["searchInput"]

  createDashboard(event) {
    event.preventDefault();
    event.stopPropagation();

    const createUrl = event.params?.createUrl;
    if (createUrl) {
      URL.turboFormVisit(createUrl, "POST");
    }
  }

  async toggleFavorite(event) {
    event.preventDefault();
    event.stopPropagation();

    const favoriteUrl = event.params?.favoriteUrl;
    if (favoriteUrl) {
      await fetchTurbo({
        path: favoriteUrl,
        method: "PATCH",
        jsonBody: {
          startingFilter: this.searchInputTarget.value
        }
      })
    }
  }
}
